import { axiosGet } from '@/api/handlers';
import { useQuery } from '@/api/hooks';
import type { z } from 'zod';

import {
  CommentInputCandidateOrganizationsModel,
  type CommentInputCandidateParamsSchema,
  CommentInputCandidateUsersModel,
} from '../models/input-candidate';
import { commentQueryKeyMap } from '../utils/query-keys';

export const useCommentInputCandidateUsers = <
  T extends z.infer<typeof CommentInputCandidateParamsSchema>,
  U = z.infer<typeof CommentInputCandidateUsersModel>,
>({
  params,
  select,
  enabled = true,
}: {
  params: T | undefined;
  select?: (data: z.infer<typeof CommentInputCandidateUsersModel>) => U;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: commentQueryKeyMap.commentInputCandidateUsers(params),
    queryFn: async () => {
      const res = await axiosGet(
        '/api/comments/input-candidates/users/',
        params,
      );
      return CommentInputCandidateUsersModel.parse(res);
    },
    select,
    enabled,
  });
};

export const useCommentInputCandidateOrganizations = <
  T extends z.infer<typeof CommentInputCandidateParamsSchema>,
  U = z.infer<typeof CommentInputCandidateOrganizationsModel>,
>({
  params,
  select,
  enabled = true,
}: {
  params: T | undefined;
  select?: (data: z.infer<typeof CommentInputCandidateOrganizationsModel>) => U;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: commentQueryKeyMap.commentInputCandidateOrganizations(params),
    queryFn: async () => {
      const res = await axiosGet(
        '/api/comments/input-candidates/organizations/',
        params,
      );
      return CommentInputCandidateOrganizationsModel.parse(res);
    },
    select,
    enabled,
  });
};
